import React, { useState } from "react";
import { endpoints } from "../api";

const Profile = () => {
  const userEmail = localStorage.getItem("user_email");
  const [loading, setLoading] = useState(false);
  
  const [accountForm, setAccountForm] = useState({
    company_name: localStorage.getItem("user_company") || "",
    industry: localStorage.getItem("user_industry") || "",
    password: "",
  });

  const [marketingForm, setMarketingForm] = useState({
    marketing_email: "",
    marketing_password: "",
  });

  const handleUpdateAccount = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await endpoints.updateAccount({ user_email: userEmail, ...accountForm });
      alert("Account updated successfully!");
      // Update local storage if company/industry changed
      localStorage.setItem("user_company", accountForm.company_name);
      localStorage.setItem("user_industry", accountForm.industry);
    } catch (err) {
      alert("Failed to update account");
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateMarketing = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await endpoints.updateMarketingCreds({ user_email: userEmail, ...marketingForm });
      alert("Marketing credentials saved!");
    } catch (err) {
      alert("Failed to save credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ color: "white", maxWidth: "800px", margin: "0 auto" }}>
      <h2 style={{ marginBottom: "30px" }}>User Profile</h2>

      <div style={{ display: "flex", gridTemplateColumns: "1fr 1fr", gap: "30px" }}>
        
        {/* Account Settings */}
        <div className="auth-card" style={{ padding: "30px", margin: 0 }}>
          <h3 style={{ marginTop: 0, color: "var(--accent)" }}>Account Settings</h3>
          <form onSubmit={handleUpdateAccount}>
            <div className="input-group">
              <label>Company Name</label>
              <input 
                value={accountForm.company_name}
                onChange={e => setAccountForm({...accountForm, company_name: e.target.value})}
              />
            </div>
            <div className="input-group" style={{ marginTop: "15px" }}>
              <label>Industry</label>
              <input 
                value={accountForm.industry}
                onChange={e => setAccountForm({...accountForm, industry: e.target.value})}
              />
            </div>
            <div className="input-group" style={{ marginTop: "15px" }}>
              <label>New Password (Optional)</label>
              <input 
                type="password"
                placeholder="Leave blank to keep current"
                onChange={e => setAccountForm({...accountForm, password: e.target.value})}
              />
            </div>
            <button className="btn-primary" style={{ marginTop: "20px" }} disabled={loading}>
              Update Account
            </button>
          </form>
        </div>

        {/* Marketing Credentials */}
        <div className="auth-card" style={{ padding: "30px", margin: 0 }}>
          <h3 style={{ marginTop: 0, color: "var(--accent)" }}>Email Sending API</h3>
          <p style={{ fontSize: "12px", color: "var(--text-dim)", marginBottom: "20px" }}>
            Configure the email address used to send your automated campaigns.
          </p>
          <form onSubmit={handleUpdateMarketing}>
            <div className="input-group">
              <label>Marketing Email ID</label>
              <input 
                type="email"
                placeholder="e.g. outreach@company.com"
                value={marketingForm.marketing_email}
                onChange={e => setMarketingForm({...marketingForm, marketing_email: e.target.value})}
                required
              />
            </div>
            <div className="input-group" style={{ marginTop: "15px" }}>
              <label>App Password / SMTP Password</label>
              <input 
                type="password"
                placeholder="••••••••••••"
                value={marketingForm.marketing_password}
                onChange={e => setMarketingForm({...marketingForm, marketing_password: e.target.value})}
                required
              />
            </div>
            <button className="btn-primary" style={{ marginTop: "20px", background: "#4ade80", color: "#000" }} disabled={loading}>
              Save Credentials
            </button>
          </form>
        </div>

      </div>
    </div>
  );
};

export default Profile;